// extracted by mini-css-extract-plugin
module.exports = {"SelectedVenueOrderTypeHeaderTitleDiv":"styles_SelectedVenueOrderTypeHeaderTitleDiv__3KvUW","VenueOrderTypeHeaderTitleDiv":"styles_VenueOrderTypeHeaderTitleDiv__10Hb9"};